module.exports = __webpack_public_path__ + "static/media/Brand_Colours.bbb88d11.png";